import { render, staticRenderFns } from "./UnreadMessage.vue?vue&type=template&id=3f51bc9c"
import script from "./UnreadMessage.vue?vue&type=script&lang=js"
export * from "./UnreadMessage.vue?vue&type=script&lang=js"
import style0 from "./UnreadMessage.vue?vue&type=style&index=0&id=3f51bc9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports